import { render, staticRenderFns } from "./KeywordsEdit.vue?vue&type=template&id=22da0908&scoped=true"
import script from "./KeywordsEdit.vue?vue&type=script&lang=js"
export * from "./KeywordsEdit.vue?vue&type=script&lang=js"
import style0 from "./KeywordsEdit.vue?vue&type=style&index=0&id=22da0908&prod&lang=css"
import style1 from "./KeywordsEdit.vue?vue&type=style&index=1&id=22da0908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da0908",
  null
  
)

export default component.exports